import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {MatIcon} from '@angular/material/icon';

@Component({
    selector: 'ostso-toast',
    standalone: true,
    imports: [
        MatIcon
    ],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    }
}
